import { render, staticRenderFns } from "./access_table.vue?vue&type=template&id=7ff427c3&scoped=true&"
import script from "./access_table.vue?vue&type=script&lang=ts&"
export * from "./access_table.vue?vue&type=script&lang=ts&"
import style0 from "./access_table.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./access_table.vue?vue&type=style&index=1&id=7ff427c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff427c3",
  null
  
)

export default component.exports